import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Alert, Box, CircularProgress, Typography } from '@mui/material';
import { startTrade, setError } from '../../store/Slices/aiTradingSlice';
import { fetchAIBalances } from '../../store/Slices/assetSlice';

const AutomatedTradeButton = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.data);
  const { aiBalances, assetsLoading } = useSelector((state) => state.assets);
  const { loading: tradeLoading, error } = useSelector((state) => state.aiTrading);
  const { light } = useSelector((state) => state.theme);
  const balance = aiBalances[0]?.balance ?? 0;
  const assetSymbol = aiBalances[0]?.asset_id?.symbol ?? 'USDT';

  const handleStartAutomatedTrade = async () => {
    // Reset error state before new attempt
    dispatch(setError(null));
    
    if (!user.ai_wallet) {
      dispatch(setError('AI wallet not configured. Please contact support.'));
      return;
    }
    if (balance <= 0) {
      dispatch(setError(`Insufficient balance for automated trade (0.00 ${assetSymbol})`));
      return;
    }

    const investment = balance * 0.1;
    const totalDeduction = investment * 0; // Include 5% fee
    if (totalDeduction > balance) {
      dispatch(setError(`Investment + 0% fee (${totalDeduction.toFixed(2)} ${assetSymbol}) exceeds available balance (${balance.toFixed(2)} ${assetSymbol})`));
      return;
    }

    try {
      const tradeAction = await dispatch(
        startTrade({
          user_id: user._id,
          ai_wallet_id: user.ai_wallet,
          investment,
          leverage: Math.floor(Math.random() * 10) + 1,
          tradeCount: 1,
          tradeType: 'Automated',
        })
      );

      if (tradeAction.meta.requestStatus === 'fulfilled') {
        console.log('Automated trade successful, refreshing balance');
        // Delay balance refresh to ensure database update
        setTimeout(async () => {
          const balanceAction = await dispatch(fetchAIBalances({ forceRefresh: true }));
          console.log('Balance refresh response:', balanceAction.payload);
        }, 500);
      } else {
        dispatch(setError('Failed to start automated trade. Please try again.'));
        console.error('Automated trade failed:', tradeAction.payload);
      }
    } catch (err) {
      dispatch(setError('Error processing trade. Please try again.'));
      console.error('Trade error:', err);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
      {error && <Alert severity="error">{error}</Alert>}
      {/* <Typography variant="body2" sx={{ color: light ? 'text.secondary' : '#b0b0b0' }}>
        Note: A 5% fee will be deducted from the investment amount.
      </Typography> */}
      <Button
        variant="outlined"
        sx={{
          borderColor: '#F3BA2F',
          color: '#F3BA2F',
          py: 1.5,
          fontWeight: 'medium',
          transition: 'all 0.3s',
          '&:hover': { bgcolor: '#F3BA2F', color: '#fff' },
          width: { xs: '100%', sm: 'auto' },
        }}
        onClick={handleStartAutomatedTrade}
        disabled={tradeLoading || assetsLoading || balance <= 0 || !user.ai_wallet}
      >
        {tradeLoading ? <CircularProgress size={24} color="inherit" /> : 'Start Automated Trading'}
      </Button>
    </Box>
  );
};

export default AutomatedTradeButton;